import { render } from "./CurrentLocationIcon.vue?vue&type=template&id=05e70d7b"
const script = {}
script.render = render

export default script